import { getModelIntervalsTaskListUsage } from "services/models/modelDetails/modelIntervals";
import { showWarning } from "../../../../redux/common/actions";

// A Task List Number reused on another interval in this model, or in a different model,
// can make a Service CSV upload resolve to more than one interval. This is purely
// informational - it never blocks the save, which has already happened by the time this runs.
export const warnIfTaskListNoIsUsedElsewhere = async ({
	dispatch,
	t,
	name,
	modelId,
	excludeIntervalGroupId,
}) => {
	const response = await getModelIntervalsTaskListUsage({
		name,
		modelId,
		excludeIntervalGroupId,
	});

	if (!response.status) {
		return;
	}

	const {
		sameModelIntervalNames = [],
		otherModelNames = [],
	} = response.data || {};

	if (!sameModelIntervalNames.length && !otherModelNames.length) {
		return;
	}

	const items = [
		...sameModelIntervalNames.map((interval) =>
			t("message.taskListNoUsedInSameModelBullet", { interval })
		),
		...otherModelNames.map((model) =>
			t("message.taskListNoUsedInOtherModelBullet", { model })
		),
	];

	dispatch(showWarning(t("message.taskListNoUsedElsewhere", { name }), items));
};
